 
<script>
import CategoryBanner from '@/components/banner/BannerCategory.vue';
import HomeDepositMethods from '@/components/home/HomeDepositMethods';
import CategorySection from '@/components/home/CategorySection.vue';
import Search from '@/components/Search.vue';
import axios from 'axios';
import { mapGetters } from 'vuex';

export default {
  name: 'GameCategory',
  metaInfo: {
    title: 'RivoBIT: The Innovative Crypto Gambling Site'
  },
  components: {
    CategoryBanner,
    HomeDepositMethods,
    CategorySection,
    Search
  },
  data() {
    return {
      games: [],
      gamesToShow: 18,
      totalGames: 0,
      offset: 0,
      providers: [],
      selectedProvider: null,
      isDropdownOpen: false,
      favorites: JSON.parse(localStorage.getItem('favorites')) || [],
      categoryName: this.$route.params.slug || 'Games'
    };
  },
  computed: {
    ...mapGetters(['authUser']),
    sortedGames() {
      const favs = this.games.filter(g => this.favorites.includes(g._id));
      const rest = this.games.filter(g => !this.favorites.includes(g._id));
      return [...favs, ...rest];
    },
    favoriteGames() {
      return this.games.filter(game => this.favorites.includes(game._id));
    },
    favoriteCategoryWithUniqueKeys() {
      return {
        slug: 'favorites',
        name: 'Favoriler',
        img: '/img/fav.png',
        total_games: this.favoriteGames.length,
        games: this.favoriteGames.map(g => ({ ...g, _id: `fav-${g._id}` }))
      };
    }
  },
  methods: {
    async fetchProviders() {
      try {
        const category = this.categoryName.toLowerCase();
        const response = await axios.get(`/public/providers/category/${category}`);
        if (response.data.success) {
          this.providers = response.data.data;
        } else {
          console.error('Failed to fetch providers:', response.data.message);
        }
      } catch (error) {
        console.error('Error fetching providers:', error);
      }
    },

    async fetchGames(reset = false) {
      try {
        const category = this.categoryName.toLowerCase();
        const params = {
          limit: this.gamesToShow,
          offset: this.offset,
          provider_code: this.selectedProvider?.provider_code || null
        };

        const response = await axios.get(`/public/games/category/${category}`, { params });

        const responseData = response.data;
        const gamesArray = Array.isArray(responseData)
          ? responseData
          : responseData.data || [];

        this.totalGames = responseData.total || gamesArray.length;

        const newGames = gamesArray.filter(
          (newGame) => !this.games.some((existingGame) => existingGame._id === newGame._id)
        );

        if (reset) {
          this.games = newGames;
        } else {
          this.games.push(...newGames);
        }
      } catch (error) {
        console.error('Failed to fetch games:', error?.response?.data || error.message);
      }
    },

    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
    },

    selectProvider(provider) {
      if (this.selectedProvider?.provider_code === provider.provider_code) {
        this.selectedProvider = null;
      } else {
        this.selectedProvider = provider;
      }

      this.offset = 0;
      this.games = [];
      this.fetchGames(true);
      this.isDropdownOpen = false;
    },

    toggleFavorite(gameId) {
      const index = this.favorites.indexOf(gameId);
      if (index === -1) {
        this.favorites.push(gameId);
      } else {
        this.favorites.splice(index, 1);
      }
      localStorage.setItem('favorites', JSON.stringify(this.favorites));
    },

    launchGame(game) {
      this.$router.push({ name: 'GameStart', params: { id: game.game_code } });
    },

    loadMoreGames() {
      if (this.games.length < this.totalGames) {
        this.offset += this.gamesToShow;
        this.fetchGames();
      }
    }
  },
  watch: {
    '$route.params.slug': {
      handler(newSlug) {
        this.categoryName = newSlug;
        this.offset = 0;
        this.games = [];
        this.fetchGames(true);
        this.fetchProviders();
      },
      immediate: true
    }
  }
};
</script>


 <template>
  <div class="home">
    <!-- Banner -->
    <div class="home-banner">
      <CategoryBanner :slug="categoryName" />
    </div>

     <!-- Search -->
      <div class="search-container">
        <Search />
      </div>

    <!-- Arama + Filter / Provider -->
    <div class="search-provider-row">
      <!-- Mobilde yan yana -->
      <div class="mobile-filter-provider">
        <div class="filter-dropdown">
          <img src="@/assets/img/filter.svg" alt="Filter Icon" class="filter-icon" />
          <span class="filter-text">{{ $t('category.filter') }}</span>
        </div>

        <div class="provider-dropdown-container">
          <div class="dropdown">
            <button class="dropdown-toggle" @click="toggleDropdown">
              <img src="@/assets/img/provider.svg" alt="Provider Icon" class="dropdown-icon" />
              <span class="dropdown-text">
                {{ selectedProvider ? selectedProvider.provider_code : $t('category.select') }}
              </span>
            </button>
            <div v-if="isDropdownOpen" class="dropdown-menu">
              <div
                v-for="(provider, index) in providers"
                :key="index"
                class="dropdown-item"
                @click="selectProvider(provider)"
              >
                <input
                  type="checkbox"
                  :checked="provider.provider_code === selectedProvider?.provider_code"
                />
                <span>{{ provider.provider_code }}</span>
                <span class="provider-count">({{ provider.count }})</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      

      <!-- PC’de yan yana -->
      <div class="desktop-filter-provider">
        <div class="filter-dropdown">
          <img src="@/assets/img/filter.svg" alt="Filter Icon" class="filter-icon" />
          <span class="filter-text">{{ $t('category.filter') }}</span>
        </div>

        <div class="provider-dropdown-container">
          <div class="dropdown">
            <button class="dropdown-toggle" @click="toggleDropdown">
              <img src="@/assets/img/provider.svg" alt="Provider Icon" class="dropdown-icon" />
              <span class="dropdown-text">
  {{ selectedProvider ? selectedProvider.provider_code : $t('category.select') }}
</span>

            </button>
            <div v-if="isDropdownOpen" class="dropdown-menu">
              <div
                v-for="(provider, index) in providers"
                :key="index"
                class="dropdown-item"
                @click="selectProvider(provider)"
              >
                <input
                  type="checkbox"
                  :checked="provider.provider_code === selectedProvider?.provider_code"
                />
                <span>{{ provider.provider_code }}</span>
                <span class="provider-count">({{ provider.count }})</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Kategoriler -->
    <CategorySection
      v-if="categoryName === 'favorites' && favoriteGames.length > 0"
      :category="favoriteCategoryWithUniqueKeys"
      :favorites="favorites"
      :onToggleFavorite="toggleFavorite"
      :loading="false"
      key="favorites"
    />

    <!-- Oyun listesi -->
    <div class="game-category" v-else>
      <div class="games-list">
        <div v-for="(game, index) in sortedGames" :key="index" class="game-item">
          <div class="game-card" @click="launchGame(game)">
            <img :src="game.banner" alt="Game Banner" class="game-banner" />
            <div class="game-meta">
              <div class="provider-row">
                <span class="provider-code">{{ game.provider?.name || game.provider_code }}</span>
                <span
                  class="favorite"
                  :class="{ active: favorites.includes(game._id) }"
                  @click.stop="toggleFavorite(game._id)"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    :fill="favorites.includes(game._id) ? '#FFD700' : '#1f3636'"
                  >
                    <path
                      d="M22,10.1c0.1-0.5-0.3-1.1-0.8-1.1l-5.7-0.8L12.9,3c-0.1-0.2-0.2-0.3-0.4-0.4C12,2.3,11.4,2.5,11.1,3L8.6,8.2L2.9,9
                        C2.6,9,2.4,9.1,2.3,9.3c-0.4,0.4-0.4,1,0,1.4l4.1,4l-1,5.7c0,0.2,0,0.4,0.1,0.6c0.3,0.5,0.9,0.7,1.4,0.4l5.1-2.7l5.1,2.7
                        c0.1,0.1,0.3,0.1,0.5,0.1v0c0.1,0,0.1,0,0.2,0c0.5-0.1,0.9-0.6,0.8-1.2l-1-5.7l4.1-4C21.9,10.5,22,10.3,22,10.1z"
                    />
                  </svg>
                </span>
              </div>
              <span class="game-name">{{ game.game_name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Load more -->
      <div v-if="games.length < totalGames" class="see-more-container">
        <button @click="loadMoreGames" class="see-more-button"> {{ $t('category.showmore') }}</button>
      </div>

      <!-- Progress -->
      <div v-if="totalGames > 0" class="game-progress-info">
        <div class="progress-bar">
          <div
            class="progress-fill"
            :style="{ width: `${(games.length / totalGames) * 100}%` }"
          ></div>
        </div>
        <div class="progress-text">
           {{ $t('category.shown') }} {{ games.length }} {{ $t('category.of') }} {{ totalGames }} {{ $t('category.games') }}
        </div>
      </div>
    </div>
 
  </div>
</template>

<style scoped>
/* Genel */
.home {
  width: 100%;
  max-width: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.home-banner {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}

/* Filter - Provider - Search */
.search-provider-row {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  width: 100%;
  margin: 10px 0 20px;
}

.filter-dropdown {
  background: var(--search-bg);
  color: white;
  padding: 10px;
  border-radius: 5px;
  font-family: var(--font-header);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
      outline: #253c3f  solid 2px;
}

.filter-icon {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.desktop-filter-provider {
  display: none;
  gap: 10px;
}

.mobile-filter-provider {
  display: flex;
  gap: 10px;
  width: 100%;
}

.mobile-filter-provider > .filter-dropdown,
.mobile-filter-provider > .provider-dropdown-container {
  flex: 1;
}

.search-container {
    width: 100%;
  
}

/* Dropdown */
.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-toggle {
  background: var(--search-bg);
  color: white;
  padding: 7px 20px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  width: 190px;
  text-align: left;
  font-family: var(--font-header);
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 8px;
      outline: var(--outline) solid 2px;
      height: 39px;
}

.dropdown-icon {
  width: 20px;
  height: 20px;
}

.dropdown-menu {
  max-height: 300px;
  overflow-y: auto;
  background: var(--search-bg);
  color: white;
  border-radius: 5px;
  width: 190px;
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1000;
}

.dropdown-item {
  padding: 10px 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
}

.dropdown-item:hover {
  background: var(--background2);
}

.provider-count {
  font-size: 14px;
  opacity: 0.8;
}

/* Oyun listesi */
.game-category {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.games-list {
  display: grid;
  gap: 15px;
  grid-template-columns: repeat(auto-fit, minmax(140px, 1fr));
  width: 100%;
}

.game-item {
  position: relative;
}

.game-banner {
  width: 100%;
  max-width: 160px;
  aspect-ratio: 16/11;
  border-radius: 10px;
  object-fit: cover;
  margin: 0 auto;
}

.game-meta {
  margin-top: 5px;
  padding: 0 4px;
  position: relative;
}

.provider-code {
  font-size: 11px;
  color: #ccc;
}

.game-name {
  font-size: 14px;
  font-weight: bold;
  color: white;
  line-height: 1.2;
}

.favorite {
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

/* Load More */
.see-more-container {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}

.see-more-button {
  padding: 10px 20px;
  font-size: 14px;
      background: var(--buttonyellow);
    box-shadow: rgb(197, 106, 24) 0px -3px 0px 0px inset, rgb(255, 234, 47) 0px 2px 0px 0px inset;
    color: #fff;
    text-shadow: 0px 0px 4px #C56A18;
    border-radius: 12px;

  cursor: pointer;
  font-family: var(--font-header);
  font-weight: 600;
}

/* Progress */
.game-progress-info {
  width: 100%;
  max-width: 300px;
  margin-top: 10px;
  text-align: center;
}

.progress-bar {
  height: 8px;
  width: 100%;
  background: var(--bar-outer);
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 6px;
}

.progress-fill {
  height: 100%;
  background: var(--bar-inner);
  transition: width 0.3s ease;
}

.progress-text {
  font-size: 13px;
  color: #aaa;
  font-family: 'Rubik', sans-serif;
}

/* Responsive */
@media (max-width: 768px) {
  .desktop-filter-provider {
    display: none !important;
  }
  .mobile-filter-provider {
    display: flex;
  }
  .games-list {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
  .game-name,
  .favorite,
  .provider-code {
    display: none;
  }
}

/* PC düzeni */
@media (min-width: 769px) {
  .mobile-filter-provider {
    display: none !important;
  }

  .search-provider-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 15px;
    width: 100%;
  }

  .search-container {
    flex: 1; /* Arama genişlesin */
    min-width: 300px;
  }

  .desktop-filter-provider {
    display: flex;
    gap: 10px;
    flex-shrink: 0; /* daralmayı engeller */
  }

  .dropdown-toggle,
  .filter-dropdown {
    height: 39px;
    display: flex;
    align-items: center;
  }
}


@media (max-width: 1024px) {
    .search-bar-wrapper[data-v-7cb41050] {
        padding-left: 0;
        padding-right: 0;
    }
}
</style>
